/* import formatearNumero from "../../helpers/datos/formatearNumero";
import formatearFecha from "../../helpers/datos/formatearFecha"; */

export default function TablaIngresosTemporada(/* { catalogos, fecha1, fecha2, values } */) {

    return (
        <div id="estatus" className="tabcontent">
            {/* <div className="contenedorEstatus">
                <div className="tituloEstatus">Reporte Estatus Global ({formatearFecha(fecha1)}) al ({formatearFecha(fecha2)})</div>
                <div className="encabezadoEstatus">Estatus</div>
                <div className="encabezadoEstatus">Importe</div>
                {catalogos.estatusPoliza && catalogos.estatusPoliza.map((e, i) => [e, values[i]]).map(([estatus, ingreso]) =>
                    <>
                        <div className="filaEstatus">{estatus.estatus.toUpperCase()}</div>
                        <div className="filaEstatus">${formatearNumero((ingreso ?? 0).toFixed(2))}</div>
                    </>
                )}
                <div className="totalEstatus">Total $</div>
                <div className="importeEstatus">${formatearNumero(values.reduce((partialSum, a) => partialSum + a, 0).toFixed(2))}</div>
            </div> */}
        </div>
    );
}